<template>
  <div 
    class="progress-modal"
    v-if="pdfDownloadProgressbarVisible"
  >
    <div class="progress-modal-body">
      <div class="lottie-container" v-if="pdfDownloadProgressPercentage < 100">
        <LottieAnimation
          :animation-data="loadingAnimation"
          :auto-play="true"
          :loop="true"
          :speed="1"
          class="result-img"
          ref="anim" 
        />
      </div>
      <div class="lottie-container" style="width: 150px;" v-else>
        <LottieAnimation
          :animation-data="successAnimation"
          :auto-play="true"
          :loop="false"
          :speed="1"
          class="result-img"
          ref="anim" 
        />
      </div>
      <div class="progress-desc"  v-if="pdfDownloadProgressPercentage < 100">
        다운로드 진행 중입니다. 잠시만 기다려 주세요.
      </div>
      <div class="progress-desc" v-else>
        다운로드가 완료되었습니다.
      </div>
      <div style="width: 100%; height: 30px">
        <a-progress 
          :percent="pdfDownloadProgressPercentage" 
          :steps="10"
          :size="[30, 20]"
        />
      </div>
    </div>
  </div>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-xs-12">
        <div class="card-header pb-0 col-sm-12 d-flex">
          <div class="col-sm-12 col-xs-12">
            
            <div class="col-sm-12 col-xs-12 justify-content-between titleContainer">
              <h3 class="title">전자계약</h3>
              <h5 class="desc">물품 공급 계약, 장비 계약 등 각종 계약을 관리할 수 있습니다.</h5>
            </div>
          </div>
        </div>
        <div class="card-body px-0 pt-0 pb-2 table-with-search">
          <!-- [2026-08-24] 요약 통계 — 필터 **위**의 독립 카드 섹션.
               처음엔 「전체 N건」 옆에 칩을 붙였더니 모바일에서 다운로드 버튼들과 뒤엉켜
               레이아웃이 깨졌다(사용자 제보). 통계는 필터·액션과 성격이 다르므로 자기 카드를 준다.
               상태 카드를 누르면 그 상태로 필터링되고, 다시 누르면 해제된다. -->
          <div class="stats-card" v-if="stats.loaded">
            <div class="stats-card-head">
              <span class="stats-total-label">전체</span>
              <span class="stats-total-value">{{ formatCommaNumber(stats.total || contract.totalDocs) }}</span>
              <span class="stats-total-unit">건</span>
            </div>
            <div class="stats-grid">
              <!-- [2026-08-24] button 을 직접 flex 컨테이너로 쓰면 브라우저가 내부 자식을
                   0 높이로 압축한다(운영 실측: 라벨 width 51 / height 0 → 라벨이 사라졌다).
                   grid stretch 도 button 에는 먹지 않아 같은 행인데 높이가 달랐다.
                   그래서 레이아웃은 안쪽 span 이 맡고, button 은 껍데기로만 둔다. -->
              <button
                  v-for="s in statusChips"
                  :key="s.status"
                  class="stat-box"
                  :class="[s.tone, { active: searchFilter.status === s.status }]"
                  @click="uiHandler.applyStatusChip(s.status)"
              >
                <span class="stat-box-inner">
                  <span class="stat-box-label">{{ s.label }}</span>
                  <span class="stat-box-value">{{ formatCommaNumber(s.count) }}</span>
                </span>
              </button>
              <div class="stat-box plain" v-if="stats.thisMonth !== null">
                <span class="stat-box-inner">
                  <span class="stat-box-label">이번달 발행</span>
                  <span class="stat-box-value">{{ formatCommaNumber(stats.thisMonth) }}</span>
                </span>
              </div>
            </div>
            <div class="stats-types" v-if="topContractTypes.length">
              <span class="stats-types-label">분류별</span>
              <a-tooltip placement="bottom">
                <template #title>
                  <div v-for="t in stats.byContractType" :key="t.contractType">
                    {{ t.contractType }} · {{ formatCommaNumber(t.count) }}건
                  </div>
                </template>
                <span class="stats-types-list">
                  <span class="stats-type-item" v-for="t in topContractTypes" :key="t.contractType">
                    {{ t.contractType }} <b>{{ formatCommaNumber(t.count) }}</b>
                  </span>
                  <span class="stats-type-more" v-if="stats.byContractType.length > topContractTypes.length">
                    +{{ stats.byContractType.length - topContractTypes.length }}
                  </span>
                </span>
              </a-tooltip>
            </div>
          </div>
          <div class="search-filter-container table-info-filter">
            <div class="search-filter-row">
              <div class="search-filter-title">
                검색어
              </div>
              <div class="search-filter-content">
                <div class="mobile-wrap">
                  <a-select
                      style="width: 150px"
                      v-model:value="keywordOption"
                      @change="v => keywordOption = v"
                      size="small"
                  >
                    <a-select-option value="계약명">
                      계약명
                    </a-select-option>
                    <a-select-option value="부서/지점">
                      부서/지점
                    </a-select-option>
                    <a-select-option value="거래처번호">
                      거래처번호
                    </a-select-option>
                  </a-select>
                  <!-- <div class="search-input-container">
                    <div class="search-icon">
                      <i class="fa-regular fa-magnifying-glass"/>
                    </div>
                    <input
                        type="text"
                        class="search-input-text"
                        v-model="searchFilter.keyword"
                        @keyup.enter="event => uiHandler.search({title: event.target.value})"
                        @focusin="e => searchFilter.keyword = ''"
                        placeholder="검색어를 입력하세요"
                    />
                  </div> -->
                  <a-input
                      size="small"
                      v-model:value="searchFilter.keyword"
                      @keyup.enter="event => uiHandler.search({title: event.target.value})"
                      @focusin="e => searchFilter.keyword = ''"
                      :placeholder="$t('common_searchfilter_placeholder')"
                  >
                    <template #prefix>
                      <i
                          class="fa-regular fa-magnifying-glass"
                      />
                    </template>
                  </a-input>
                </div>
                <div class="mobile-wrap">
                  <a-button
                      class="black"
                      size="small"
                      @click="uiHandler.search"
                  >
                    검색
                  </a-button>
                  <a-button
                      size="small"
                      @click="event => uiHandler.reload()"
                  >
                    초기화
                  </a-button>
                </div>
              </div>
            </div>
            <div class="search-filter-row">
              <div class="search-filter-title">
                계약상태
              </div>
              <div class="search-filter-content">
                <a-select
                    style="width: 150px; min-width: 100px"
                    v-model:value="searchFilter.status"
                    @change="(val) => uiHandler.search({status: val})"
                    size="small"
                >
                  <a-select-option
                      v-for="item in searchFilter.contractStatusList.filter(s => !s.label.includes('덴티움'))"
                      :value="item.status"
                  >
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
            <!-- [2026-08-24] 자주 쓰는 검색어·계약상태만 항상 노출하고, 날짜/분류/지점은 접는다.
                 필터 6 행이 세로로 쌓여 목록이 화면 아래로 밀려나 있었다(사용자 요청).
                 접힌 상태에서도 조건이 걸려 있으면 배지로 개수를 보여줘, 접혔다는 이유로
                 필터가 걸린 사실을 놓치지 않게 한다.
                 [2026-08-25] 토글이 라벨 칸이 빈 줄을 혼자 차지해 "가운데에 떠 있다"는 지적을
                 받았다(QA). 검색 박스 맨 위에 제목 줄을 두고 그 줄 오른쪽 끝으로 옮긴다 —
                 제목이 생겨 이 영역이 무엇인지도 분명해진다. -->
            <div class="search-filter-row search-header-row">
              <div class="search-header-title">검색 조건</div>
              <a-button class="advanced-toggle-btn" size="small" type="link"
                        @click="showAdvancedFilter = !showAdvancedFilter">
                {{ showAdvancedFilter ? '상세 조건 접기' : '상세 조건 펼치기' }}
                <a-badge v-if="activeAdvancedFilterCount" :count="activeAdvancedFilterCount"
                         :number-style="{ backgroundColor: '#faad14', marginLeft: '6px' }"/>
                <span style="margin-left: 6px">{{ showAdvancedFilter ? '▲' : '▼' }}</span>
              </a-button>
            </div>
            <div class="advanced-filter-body" v-show="showAdvancedFilter">
            <div class="search-filter-row">
              <div class="search-filter-title">
                계약생성일
              </div>

              <div class="search-filter-content">
                <div class="date-filter-container-wrapper is-mobile-only">
                  <div class="date-filter-container ">
                    <div
                        class="date-filter-item"
                        :class="searchFilter.selectedDateFilter === 'all' ? 'selected' : ''"
                        @click="uiHandler.handleDateFilter('all')"
                    >
                      {{ $t('common_total') }}
                    </div>
                    <div
                        v-for="item in searchFilter.dateFilters.slice(0,1)"
                        class="date-filter-item"
                        :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"
                        @click="uiHandler.handleDateFilter(item)"
                    >
                      {{
                        item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${uiHandler.convertMonthAndYearText(item)}`
                      }}
                    </div>
                  </div>
                  <div class="date-filter-container ">
                    <div
                        v-for="item in searchFilter.dateFilters.slice(1,3)"
                        class="date-filter-item"
                        :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"
                        @click="uiHandler.handleDateFilter(item)"
                    >
                      {{
                        item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${uiHandler.convertMonthAndYearText(item)}`
                      }}
                    </div>
                  </div>
                  <div class="date-filter-container  " style="width: 100%;">
                    <div
                        v-for="item in searchFilter.dateFilters.slice(3,4)"
                        class="date-filter-item"
                        :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"
                        style="width: 100%;border-bottom: 1px solid rgba(0, 0, 0, 0.15);"
                        @click="uiHandler.handleDateFilter(item)"
                    >
                      {{
                        item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${uiHandler.convertMonthAndYearText(item)}`
                      }}
                    </div>
                  </div>
                </div>
                <div class="date-filter-container is-desktop-tablet">
                  <div
                      class="date-filter-item"
                      :class="searchFilter.selectedDateFilter === 'all' ? 'selected' : ''"
                      @click="uiHandler.handleDateFilter('all')"
                  >
                    {{ $t('common_total') }}
                  </div>
                  <div
                      v-for="item in searchFilter.dateFilters"
                      class="date-filter-item"
                      :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"
                      @click="uiHandler.handleDateFilter(item)"
                  >
                    {{
                      item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${uiHandler.convertMonthAndYearText(item)}`
                    }}
                  </div>
                </div>

                <div class="date-selector-container custom" v-if="searchFilter.selectedDateFilter === 'etc'">
                  <a-range-picker
                      size="small"
                      :allowClear="false"
                      :locale="locale"
                      v-model:value="dateRanges"
                      @change="uiHandler.search"
                      style="width: 250px; margin-bottom: 10px"
                  />
                </div>
              </div>
            </div>
            <div class="search-filter-row">
              <div class="search-filter-title">
                계약일
              </div>

              <div class="search-filter-content">
                <div class="date-filter-container-wrapper is-mobile-only">
                  <div class="date-filter-container ">
                    <div
                        class="date-filter-item"
                        :class="searchFilter.selectedDateFilterForContractDate === 'all' ? 'selected' : ''"
                        @click="uiHandler.handleDateFilterForContractDate('all')"
                    >
                      {{ $t('common_total') }}
                    </div>
                    <div
                        v-for="item in searchFilter.dateFiltersForContractDate.slice(0,1)"
                        class="date-filter-item"
                        :class="searchFilter.selectedDateFilterForContractDate === item ? 'selected' : ''"
                        @click="uiHandler.handleDateFilterForContractDate(item)"
                    >
                      {{
                        item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${uiHandler.convertMonthAndYearText(item)}`
                      }}
                    </div>
                  </div>
                  <div class="date-filter-container ">
                    <div
                        v-for="item in searchFilter.dateFiltersForContractDate.slice(1,3)"
                        class="date-filter-item"
                        :class="searchFilter.selectedDateFilterForContractDate === item ? 'selected' : ''"
                        @click="uiHandler.handleDateFilterForContractDate(item)"
                    >
                      {{
                        item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${uiHandler.convertMonthAndYearText(item)}`
                      }}
                    </div>
                  </div>
                  <div class="date-filter-container  " style="width: 100%;">
                    <div
                        v-for="item in searchFilter.dateFiltersForContractDate.slice(3,4)"
                        class="date-filter-item"
                        :class="searchFilter.selectedDateFilterForContractDate === item ? 'selected' : ''"
                        style="width: 100%;border-bottom: 1px solid rgba(0, 0, 0, 0.15);"
                        @click="uiHandler.handleDateFilterForContractDate(item)"
                    >
                      {{
                        item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${uiHandler.convertMonthAndYearText(item)}`
                      }}
                    </div>
                  </div>
                </div>
                <div class="date-filter-container is-desktop-tablet">
                  <div
                      class="date-filter-item"
                      :class="searchFilter.selectedDateFilterForContractDate === 'all' ? 'selected' : ''"
                      @click="uiHandler.handleDateFilterForContractDate('all')"
                  >
                    {{ $t('common_total') }}
                  </div>
                  <div
                      v-for="item in searchFilter.dateFiltersForContractDate"
                      class="date-filter-item"
                      :class="searchFilter.selectedDateFilterForContractDate === item ? 'selected' : ''"
                      @click="uiHandler.handleDateFilterForContractDate(item)"
                  >
                    {{
                      item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${uiHandler.convertMonthAndYearText(item)}`
                    }}
                  </div>
                </div>

                <div class="date-selector-container custom"
                     v-if="searchFilter.selectedDateFilterForContractDate === 'etc'">
                  <a-range-picker
                      size="small"
                      :allowClear="false" :locale="locale" v-model:value="dateRangesForContractDate"
                      @change="uiHandler.search"
                      style="width: 250px; margin-bottom: 10px"
                  />
                </div>
              </div>
            </div>
            <div class="search-filter-row">
              <div class="search-filter-title">
                계약분류
              </div>
              <div class="search-filter-content">
                <a-select
                    style="width: 150px; min-width: 100px"
                    v-model:value="searchFilter.contractSubGroup"
                    @change="(val) => uiHandler.search({contractSubGroup: val})"
                    size="small"
                    :notFoundContent="null"
                >
                  <a-select-option
                      v-for="item in contractTypeListByManufacturer"
                      :value="item.contractSubGroup"
                  >
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
            <div class="search-filter-row" v-if="visibleDeptSelectBox">
              <div class="search-filter-title">
                지점
              </div>
              <div class="search-filter-content">
                <a-select
                    show-search
                    size="small"
                    style="width: 150px; min-width: 100px"
                    v-model:value="searchFilter.deptName"
                    @change="async (val) => {
                    this.keywordOption = '부서/지점'
                    searchFilter.keyword = val
                    await uiHandler.search(searchFilter)
                  }"
                    :options="deptNames"
                    :notFoundContent="null"
                />

              </div>
            </div>
            </div>
          </div>
          <div class="col-xs-12 table-info-filter">
            <!-- [2026-08-24] 통계 카드에 이미 전체 건수가 있어 중복이다. 모바일에서는 이 영역이
                 45px 로 눌려 "전체 / 10,629 / 건" 이 3 줄로 깨지기까지 했다(실측).
                 통계를 못 받은 경우에만 남긴다 — 그때는 이게 유일한 건수 표시다. -->
            <div class="total-div" v-if="!stats.loaded">
              <p>
                {{ $t('common_total') }}
                <span class="number-highlight">{{ formatCommaNumber(contract.totalDocs) }}</span>
                {{ $t('common_case') }}
              </p>
            </div>
            <div class="search-container">
              <a-button
                  @click="uiHandler.fetchContractsExcel"
                  type="primary"
                  class="no-mobile"
              >
                <i class="fa-solid fa-download"/>
                엑셀 다운로드
              </a-button>
              <a-tooltip placement="top" title="⚠️ 최대 한번에 500개 까지 다운로드 가능합니다.(500건 다운로드시 대략 5분 소요)">
                <a-button
                    @click="(e) => uiHandler.fetchContractsPdfDownload(this.searchFilter)"
                    type="primary"
                    class="no-mobile"
                >
                  <i class="fa-solid fa-download"/>
                  PDF 다운로드
                </a-button>
              </a-tooltip>
              <a-button
                  @click="uiHandler.routeToContractType"
                  type="primary"
                  v-if="visibleCreateContractBtn"
              >
                <i class="fa-solid fa-plus"/>
                신규 계약
              </a-button>
              <a-button
                  @click="uiHandler.deleteContracts"
                  type="primary"
                  v-if="visibleDeleteCompleteBtn"
              >
                <i class="fa-solid fa-trash"/>
                삭제완료
              </a-button>
              <a-button
                  @click="uiHandler.toggleCheckboxColumn"
                  type="primary"
                  class="no-mobile"
                  v-if="visibleDeleteContractBtn"
              >
                <i class="fa-solid fa-trash"/>
                {{ deleteContractTxt }}
              </a-button>
              <a-select class="search-select" v-model:value="paginationData.rowsPerPage" style="width: 120px"
                        @change="uiHandler.search">
                <a-select-option :value="10" selected>10{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                <a-select-option :value="20">20{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                <a-select-option :value="50">50{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
              </a-select>
            </div>
          </div>
          <div
              class="card content-wrap-card col-sm-12 col-xs-12 tableCard p-0"
              style="border-radius: 0 !important; border: none !important; background: white !important; border-radius: 0px;"
          >
            <div class="table-responsive table-wrap">
              <!-- [2026-08-24] 모바일 카드 목록.
                   15 컬럼 테이블을 좁은 화면에서 가로로 밀어 봐야 했고, 부가기능 컬럼은 아예
                   숨겨져 있어(`!isMobile`) 현장에서 계약서 열람·재발송을 할 수 없었다.
                   조회와 현장 작업을 둘 다 하신다고 해서(사용자 확인) 카드 안에 동작 버튼을 넣는다.
                   데스크톱은 기존 테이블 그대로 — 컬럼이 많은 화면은 표가 더 낫다. -->
              <div class="contract-card-list" v-if="isMobile && contract.list.length > 0">
                <div class="contract-card" v-for="record in contract.list" :key="record.contractId">
                  <div class="cc-top">
                    <a-tag class="cc-type">{{ record.contractType || '-' }}</a-tag>
                    <span class="cc-status" :class="uiHandler.convertProgressClass(record.status, record.signingParty)">
                      {{ uiHandler.convertProgressMessage(record.status, record.signingParty) }}
                    </span>
                  </div>
                  <div class="cc-title">{{ record.title }}</div>
                  <div class="cc-meta">
                    <!-- 거래처 표기는 목록 컬럼과 같은 규칙: 병원명이 있으면 그것을 먼저 쓴다 -->
                    <span>{{ record.hospitalName || record.clients?.[0]?.name || '-' }}</span>
                    <span class="cc-dot">·</span>
                    <span>{{ record.deptName || '-' }}</span>
                  </div>
                  <div class="cc-meta">
                    <!-- 목록 컬럼과 같은 값을 쓴다(서버가 이미 KST 문자열로 내려준다) -->
                    <span>생성 {{ record.createContractDate || '-' }}</span>
                    <span class="cc-dot">·</span>
                    <span>담당 {{ record.contractManager?.name || '-' }}</span>
                  </div>
                  <div class="cc-actions">
                    <a-button size="small" @click="uiHandler.fileDownload(record)">계약서 보기</a-button>
                    <a-button
                        size="small"
                        v-if="record.status === 'SIGNING'"
                        @click="uiHandler.additionalFunc.resendRequest(record)"
                    >
                      {{ uiHandler.currentSignMethod(record).isKakao ? '서명요청 재전송' : '대면서명' }}
                    </a-button>
                    <a-button
                        size="small"
                        v-if="record.status === 'COMPLETED'"
                        @click="uiHandler.additionalFunc.sendCompleteContract(record)"
                    >
                      완료본 재발송
                    </a-button>
                  </div>
                </div>
              </div>

              <a-table class="ant-table-striped"
                       size="small"
                       :columns="columns"
                       :data-source="contract.list"
                       :pagination="false"
                       v-if="!isMobile && contract.list.length > 0"
              >
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'additional-func' && !isMobile">
                    <div class="extra-btn-wrap" v-if="record.status === 'SIGNING'">
                      <a-tooltip placement="top">
                        <template #title>
                          <span v-if="uiHandler.currentSignMethod(record).isKakao">알림톡으로 서명 요청 재전송</span>
                          <span v-if="uiHandler.currentSignMethod(record).isSecureLink">대면서명 다시하기</span>
                        </template>
                        <a-button
                            shape="circle"
                            @click="uiHandler.additionalFunc.resendRequest(record)"
                        >
                          <template #icon>
                            <img src="@/assets/icons/kakao_alimtalk_icon.svg" alt="카카오 아이콘"
                                 v-if="uiHandler.currentSignMethod(record).isKakao">
                            <i
                                v-if="uiHandler.currentSignMethod(record).isSecureLink"
                                class="fa-regular fa-file-signature"
                            />
                          </template>
                        </a-button>
                      </a-tooltip>
                      <!-- [2026-08-24] 프릭스 계약은 이 버튼을 감춘다. 프릭스 kit-api 에 만료일 변경이
                           없어(expiredDate 는 발행 시 고정, 어댑터 notImplemented) 누르면 항상 500 이
                           떨어지기 때문이다(운영 실측). 실패할 걸 알면서 버튼을 노출하지 않는다.
                           프릭스가 대응 API 를 내놓으면 이 v-if 만 지우면 된다. -->
                      <a-tooltip placement="top" v-if="record.serviceProvider !== 'PRIX'">
                        <template #title>
                          서명 기간 수정
                        </template>
                        <a-button
                            shape="circle"
                            data-bs-toggle="modal"
                            data-bs-target="#contract-expiration-modal"
                            @click="uiHandler.additionalFunc.selectContract(record)"
                        >
                          <template #icon>
                            <i class="fa-solid fa-pen-to-square"/>
                          </template>
                        </a-button>
                      </a-tooltip>
                      <a-tooltip placement="top">
                        <template #title>
                          서명 요청 취소하기
                        </template>
                        <a-button
                            shape="circle"
                            @click="uiHandler.additionalFunc.cancelContract(record)"
                        >
                          <template #icon>
                            <i class="fa-solid fa-trash-can"/>
                          </template>
                        </a-button>
                      </a-tooltip>
                      <a-tooltip placement="top" v-if="uiHandler.clientSyncVisible(record)">
                        <template #title>
                          거래처 연동하기
                        </template>
                        <a-button
                            shape="circle"
                            @click="(e) => uiHandler.handleModal.client.show(record.contractId)"
                        >
                          <template #icon>
                            <i class="fa-duotone fa-arrows-rotate"/>
                          </template>
                        </a-button>
                      </a-tooltip>
                    </div>
                    <div class="extra-btn-wrap" v-else-if="record.status === 'COMPLETED'">
                      <a-tooltip placement="top">
                        <template #title>
                          완료된 계약서(PDF) 재발송
                        </template>
                        <a-button
                            shape="circle"
                            @click="uiHandler.additionalFunc.sendCompleteContract(record)"
                        >
                          <template #icon>
                            <i class="fa-regular fa-paper-plane-top"/>
                          </template>
                        </a-button>
                      </a-tooltip>
                      <a-tooltip placement="top" v-if="uiHandler.clientSyncVisible(record)">
                        <template #title>
                          거래처 연동하기
                        </template>
                        <a-button
                            shape="circle"
                            @click="(e) => uiHandler.handleModal.client.show(record.contractId)"
                        >
                          <template #icon>
                            <i class="fa-duotone fa-arrows-rotate"/>
                          </template>
                        </a-button>
                      </a-tooltip>
                    </div>
                    <div v-else>
                      <span>-</span>
                    </div>
                  </template>
                </template>
              </a-table>
              <!-- [2026-08-25] `v-else` 를 쓰면 안 된다. 이 else 는 바로 위 a-table 의
                   `v-if="!isMobile && ..."` 에 묶이므로, **모바일에서는 목록이 있어도**
                   테이블이 렌더되지 않아 빈 상태 박스가 카드 아래에 함께 나왔다
                   (2026-08-25 모바일 실측 제보). 08-24 에 카드 목록을 별도 `v-if` 로
                   추가하면서 원래의 표↔빈상태 if/else 짝이 깨진 것이 원인이다.
                   결과 없음 판정은 화면 폭과 무관하므로 이미 있는 `noResult` 를 쓴다 —
                   하단 pagination(`v-if="!noResult"`)과 같은 근거를 보게 되어
                   "표는 없는데 페이지네이션은 있는" 식의 불일치도 함께 사라진다. -->
              <div class="no-result-container" v-if="noResult">
                  <i class="fa-solid fa-exclamation-triangle" />
                  <span>{{ computedNoResultMessage }} </span>
              </div>
            </div>
          </div>
        </div>
        <pagination
            v-if="!noResult"
            :page-info="paginationData"
            page-name="ContractList"
            @change-page="uiHandler.paginationHandler"
        />
      </div>
    </div>
  </div>
  <contract-expiration-modal
      @emit-expiration-date="uiHandler.receiveExpirationDate"
      :selected-contract="selectedContract"
  />
  <search-client-modal
      :show-modal="modal.client.show"
      @close-modal="uiHandler.handleModal.client.close"
      @complete-search="uiHandler.handleModal.client.handleEvent.selectClient"
  />
</template>
<script>
import { getAccessToken, getProfile } from '@/utils/tokenStore';
import { masterCheckUsername } from '@/utils/supportMaster';
// 거래처담당자가 두번째
// 처음이 계약담당자
// 마지막이 거래처
// 라벨스에 거래처

import {RouterEnum} from "@/enums/router.enums";
import ContractExpirationModal from '@/views/ContractManagement/components/ContractExpirationModal';
import {
  convertDate,
  dateUtils,
  formatCommaNumber,
  jwtDecoder,
  logging,
  oneBtnDialog,
  twoBtnDialog,
} from "@/utils/utils";
import NoResult from "@/views/components/NoResult.vue";
import Pagination from "@/views/components/Pagination.vue";
import {localStorageEnums} from "@/enums/localStorage.enums";
import {ContractTypeEnum, CustomeSignMethod, ModuSignMethod} from "@/views/ContractManagement/enums";
import {styles} from "@/views/ContractManagement/styles";
import SearchClientModal from "@/views/ContractManagement/components/SearchClientModal.vue";
// v5: contracts-api 전용 API 모듈 + axios 인스턴스로 교체. v1 api.js/axios.js는 건드리지 않는다.
// 주의: SearchClientModal은 v1 컴포넌트를 그대로 재사용하며, 내부적으로 this.$apiInstance(v1/inapi)의
// /companies/list/contract/v4 를 직접 호출한다(이 v4 는 inapi 백엔드 엔드포인트 버전이며 이 화면의
// v4→v5 개명과 무관하다 — 건드리지 않는다). 거래처(companies) 도메인은 이번 전자계약 v5 전환
// 범위에 포함되지 않아(엔드포인트 표에 없음) 의도적으로 그대로 뒀다 — 화면 UI만 그대로 재사용.
import contractApi from "@/views/ContractManagementV5/api";
import contractsApiInstance from "@/contractsApi";
import {fetchContractViewCapabilities} from "@/views/ContractManagementV5/capabilities";
import locale from 'ant-design-vue/es/date-picker/locale/ko_KR';
import dayjs from "dayjs";
import 'dayjs/locale/ko'
import { LottieAnimation } from "lottie-web-vue";
import loadingAnimation from "@/assets/img/bulk_loading.json";
import successAnimation from "@/assets/img/success.json";

import {CONTRACT_TYPES_PATH} from '@/utils/contractConsole';
export default {
  // v1과 라우트 name이 충돌하지 않도록 RouterEnum을 쓰지 않고 별도 하드코딩.
  name: 'ContractListV5',
  components: {
    SearchClientModal,
    Pagination,
    NoResult,
    ContractExpirationModal,
    LottieAnimation,
  },
  computed: {
    /**
     * 접힌 상세 필터에 실제로 걸려 있는 조건 수 — 배지로 보여준다.
     * 접혔다는 이유로 "왜 결과가 적지?" 를 헤매지 않게 하는 장치다.
     */
    activeAdvancedFilterCount() {
      const f = this.searchFilter;
      let n = 0;
      if (f.selectedDateFilter && f.selectedDateFilter !== 'all') n += 1;
      if (f.selectedDateFilterForContractDate && f.selectedDateFilterForContractDate !== 'all') n += 1;
      if (f.contractSubGroup) n += 1;
      if (f.deptName) n += 1;
      return n;
    },
    /** 상태 칩 — 백엔드 중립 어휘를 화면 문구로 옮긴다. 0 건이어도 보여줘 분포를 알 수 있게 한다. */
    statusChips() {
      const by = this.stats.byStatus || {};
      return [
        { status: 'SIGNING', label: '서명 진행중', count: by.SIGNING || 0, tone: 'orange' },
        { status: 'COMPLETED', label: '모든 서명 완료', count: by.COMPLETED || 0, tone: 'green' },
        { status: 'CANCELED', label: '서명 중단됨', count: by.CANCELED || 0, tone: 'red' },
        // [2026-09-07] 기한이 지난 진행중 계약. 프로바이더가 만료를 상태로 주지 않아
        // 백엔드가 읽기 시점에 날짜로 갈라 준다. 이 칩이 없으면 만료 건이 어느 카운트에도
        // 안 잡혀 화면에서 조용히 사라진다.
        { status: 'EXPIRED', label: '기한 만료', count: by.EXPIRED || 0, tone: 'gray' },
      ];
    },
    /** 분류별은 종류가 12 개까지 있어 상위 3 개만 노출하고 전체는 툴팁으로 넘긴다. */
    topContractTypes() {
      return (this.stats.byContractType || []).slice(0, 3);
    },
    noResult() {
      return !this.$store.state.isLoading && this.contract.totalDocs === 0
    },
    computedNoResultMessage() {
      if (this.contract.list.length <= 1) {
        return '아직 등록된 계약이 없습니다.';
      } else {
        return this.$i18n.t('noresult_search');
      }
    },
    // 마스터 비교용 아이디 — 지원 탭이면 그 회사 최상위 관리자(utils/supportMaster)
    checkUsername() {
      return masterCheckUsername(this.companyInfo?.accountInfo?.username, this.$store.state.privileges)
    },
    isDentiumAdmin() {
      return this.checkUsername === 'dentium'
    },
    isDentiumEquipMaster() {
      return this.checkUsername === 'dentium03'
    },
    isDentiumCsTeam() {
      // 지점 소속 CS 엔지니어 명단은 권한관리 화면 데이터다 — 포함 여부만 서버(capabilities)에서 받는다.
      // 소속 판단은 기존과 같은 출처(로그인 시 저장된 계정 정보)를 그대로 쓴다(SPEC-CONTRACT-VIEW-GRANT-001).
      return this.companyInfo?.accountInfo?.deptName === '고객지원팀'
        || this.capabilities?.csEngineer === true
    },
    isDentiumEquipQualityTeam() {
      return this.companyInfo?.accountInfo?.deptName === '장비품질팀'
    },
    isPlasmappAdmin() {
      return this.checkUsername === 'bkpark1@plasmapp.com' || this.checkUsername === 'plasmapp'
    },
    visibleCreateContractBtn() {
      return !this.isDentiumEquipMaster
    },
    visibleDeleteContractBtn() {
      return (this.isDentiumAdmin || this.isPlasmappAdmin) && !this.isCheckboxVisible
    },
    visibleDeleteCompleteBtn() {
      return this.isCheckboxVisible
    },
    visibleDeptSelectBox() {
      return this.isDentiumAdmin || this.isDentiumEquipMaster
    },
    deleteContractTxt() {
      return this.isCheckboxVisible ? '돌아가기' : '계약 삭제'
    },
    isMobile() {
      return this.windowWidth < 768;
    },
    contractTypeListByManufacturer() {
      const companyId = jwtDecoder(getAccessToken());
      if (companyId === process.env.VUE_APP_DENTIUM_ID) {
        if (this.isDentiumAdmin) {
          return this.searchFilter.contractSubGroupList.filter(ct => ct.companyId === companyId)
        } else if (this.isDentiumCsTeam || this.isDentiumEquipQualityTeam) {
          return this.searchFilter.contractSubGroupList.filter(ct => ct.companyId === companyId).filter(ct => !ct.deptName || ct.deptName === '고객지원')
        } else if (!this.capabilities) {
          // CS 명단 포함 여부 응답 전 — 소속만으로 결론이 안 나는 사용자는 잘못된 분류를 잠깐이라도 보이지 않게 비워 둔다
          return []
        } else {
          return this.searchFilter.contractSubGroupList.filter(ct => ct.companyId === companyId).filter(ct => ct.deptName !== '고객지원')
        }
      } else if (companyId === process.env.VUE_APP_PLASMAPP_ID) {
        return this.searchFilter.contractSubGroupList.filter(ct => ct.companyId === companyId)
      } else {
        return this.searchFilter.contractSubGroupList.filter(ct => ct.companyId === companyId)
      }
    }
  },
  data() {
    const columns = [
      {
        key: 'index', title: '번호', dataIndex: 'index', align: 'center', width: 40,
        customRender: ({text, record}) => {
          return (
              <div style="display: flex; justify-content: center" onClick={async (e) => {
                await navigator.clipboard.writeText(record.contractId);
              }}>
                {record.index}
              </div>
          )
        }
      },
      {
        key: 'contractType', title: '계약분류', dataIndex: 'contractType', align: 'center',
        customRender: ({text, record}) => {
          return (
              <div style="display: flex; justify-content: center">
                {record.contractType ?
                    <a-tag style={{...styles.tags.statusTag, ...styles.tags.blue}}>
                      <span style={{fontSize: '14px'}}>{record.contractType}</span>
                    </a-tag> : <span>-</span>
                }
              </div>
          )
        }
      },
      {
        key: 'createContractDate',
        title: () => {
          return (
              <div style="display: flex; align-items: center; justify-content: center; gap: 4px">
                계약생성일
                <a-tooltip title="전자계약서를 생성한 날짜" trigger="click">
                  <i class="fa-regular fa-info-circle" />
                </a-tooltip>
              </div>
          )
        },
        dataIndex: 'createContractDate', align: 'center',
        customRender: ({text}) => {
          return (
              <a-typography-text>{text}</a-typography-text>
          )
        }
      },
      {
        key: 'contractDate',
        title: () => {
          return (
              <div style="display: flex; align-items: center; justify-content: center; gap: 4px">
                계약일
                <a-tooltip title="계약서 문서상의 계약일"  trigger="click">
                  <i class="fa-regular fa-info-circle" />
                </a-tooltip>
              </div>
          )
        },
        dataIndex: 'contractDate', align: 'center',
        customRender: ({text}) => {
          return (
              <a-typography-text>{dayjs(text).format("YYYY/MM/DD")}</a-typography-text>
          )
        }
      },
      {
        key: 'title', title: '계약명', dataIndex: 'title', align: 'center',
        customRender: ({text, record}) => {
          if (record.title) {
            return (
                <a-tooltip placement="top" title={record.title}>
                  <a-typography-text ellipsis style={{width: '160px', cursor: 'pointer'}}>
                    {record.title}
                  </a-typography-text>
                </a-tooltip>
            );
          }
          return null;
        }
      },
      {
        key: 'totalAmount', title: '계약금액', dataIndex: 'totalAmount', align: 'center',
        customRender: ({text, record}) => {
          const amount = record?.totalAmount?.toLocaleString();
          logging().exceptProd("record==>", record)
          logging().exceptProd("isOneTimePayment record==>", record?.paymentInfos?.isOneTimePayment)
          const companyId = jwtDecoder(getAccessToken());
          if (process.env.VUE_APP_PLASMAPP_ID === companyId) {
            if (record?.paymentInfos?.isOneTimePayment === 'Y') {
              return (
                  <div style={{display: 'flex', justifyContent: 'end'}}>
                    <a-typography-text>{amount}원</a-typography-text>
                  </div>
              )
            } else {
              return (
                  <div style={{display: 'flex', justifyContent: 'end'}}>
                    <a-typography-text>월 {amount}원</a-typography-text>
                  </div>
              )
            }
          } else {
            console.log("amount===>", record?.totalAmount)
            return (
                <div style={{display: 'flex', justifyContent: 'end'}}>
                  {record?.totalAmount > 0 ?
                      <a-typography-text>{amount}원</a-typography-text> :
                      <a-typography-text>-</a-typography-text>}
                </div>
            )
          }
        }
      },
      {
        key: 'clientName', title: '거래처', dataIndex: 'clientName', align: 'center',
        customRender: ({text, record}) => {
          let clientName = (record.clients && record.clients[0]) ? record.clients[0].name : '-';
          return (
              <a-tooltip placement="top" title={clientName}>
                <a-typography-text ellipsis style={{width: '90px', cursor: "pointer"}}>
                  {record.hospitalName ? record.hospitalName : clientName}
                </a-typography-text>
              </a-tooltip>
          )
        }
      },
      {
        key: 'clientManager', title: '거래처 담당자', dataIndex: 'clientManager', align: 'left',
        customRender: ({text, record}) => {
          let clientManager = (record.clients && record.clients[0]) ? record.clients[0].manager : '-';
          let mobile = (record.clients && record.clients[0]) ? record.clients[0].mobile : '-';
          let email = record.clientEmail ? record.clientEmail : '-';
          let managerInfo = this.uiHandler.getManagerInfo(record.clients[0]);
          return (
              <div>
                <div style={{...styles.manager.name}}>
                  {clientManager}
                </div>
                <a-tooltip placement="top" title={
                  <div>
                    <span style={{...styles.manager.desc}}>모바일: </span>
                    <a-typography-text style={{...styles.manager.desc}} copyable> {mobile} </a-typography-text>
                    <br/>
                    <span style={{...styles.manager.desc}}>이메일: </span>
                    <a-typography-text style={{...styles.manager.desc}} copyable> {email} </a-typography-text>
                  </div>
                }>
                  <a-typography-text ellipsis style={{width: '90px', cursor: "pointer"}}>
                    <span style={{...styles.manager.desc}}> {managerInfo} </span>
                  </a-typography-text>
                </a-tooltip>
              </div>
          )
        }
      },
      {
        key: 'contractManagerName', title: '계약 담당자', dataIndex: 'contractManagerName', align: 'center',
        customRender: ({text, record}) => {
          let contractManagerName = record.contractManager ? record.contractManager.name : '-';
          return (
              <a-typography-text ellipsis style={{width: '90px'}}>
                {contractManagerName}
              </a-typography-text>
          )
        }
      },
      // {
      //   key: 'signMethod', title: '서명방식', dataIndex: 'signMethod', align: 'center',
      //   customRender: ({text, record}) => {
      //     if (this.uiHandler.currentSignMethod(record).isAborted) {
      //       return '-';
      //     } else {
      //       const signMethodType = record.currentParticipant?.signingMethod?.type;
      //       const signMethodTypeClass = this.uiHandler.convertProgressClass(signMethodType);
      //       const signMethod = this.uiHandler.convertSignMethod(signMethodType);
      //       return (
      //           <div style={{display: 'flex', justifyContent: 'center'}}>
      //             <a-tag style={{...styles.tags.statusTag, ...styles.tags[signMethodTypeClass]}}>
      //               <span style={{fontSize: '14px'}}> {signMethod} </span>
      //             </a-tag>
      //           </div>
      //       );
      //     }
      //   }
      // },
      {
        key: 'status', title: '진행상황', dataIndex: 'status', align: 'center',
        customRender: ({text, record}) => {
          const statusClass = this.uiHandler.convertProgressClass(record.status, record.signingParty);
          const statusMessage = this.uiHandler.convertProgressMessage(record.status, record.signingParty);
          return (
              <div style={{display: 'flex', justifyContent: 'center'}}>
                <a-tag style={{...styles.tags.statusTag, ...styles.tags[statusClass]}}>
                  <span style={{fontSize: '14px'}}>{statusMessage}</span>
                </a-tag>
              </div>
          )
        }
      },
      {
        key: 'duration', title: '유효기간', dataIndex: 'duration', align: 'center',
        customRender: ({text, record}) => {
          const duration = record.currentParticipant?.signingDue?.datetime || '';
          return <a-typography-text>{duration}</a-typography-text>;
        }
      },
    ]
    const companyId = jwtDecoder(getAccessToken());
    if (companyId && companyId === process.env.VUE_APP_DENTIUM_ID) {
      // '거래처번호' 컬럼 추가
      columns.splice(6, 0, {
        key: 'custNo',
        title: '거래처번호',
        dataIndex: 'custNo',
        align: 'center',
        customRender: ({text}) => {
          const val = text ? text : '-';
          return (
              <a-typography-text>{val}</a-typography-text>
          );
        },
      });

      // '부서/지점' 컬럼 추가
      columns.splice(9, 0, {
        key: 'deptName',
        title: '부서/지점',
        dataIndex: 'deptName',
        align: 'center',
        customRender: ({text}) => {
          const val = text ? text : '-';
          return (
              <a-typography-text>{val}</a-typography-text>
          );
        },
      });
    }
    return {
      locale,
      pdfDownloadProgressbarVisible: false,
      pdfDownloadProgressPercentage: 0,
      dateRanges: [],
      dateRangesForContractDate: [],
      dateUtil: dateUtils(),
      RouterEnum,
      formatCommaNumber,
      logging,
      convertDate,
      companyInfo: JSON.parse(getProfile('CompanyInfo')),
      capabilities: null,
      uiHandler: this.ui(),
      apiHandler: this.api(),
      contractCreator: '',
      selectedContract: {},
      keywordOption: '계약명',
      modal: {client: {show: false}},
      currentContractId: '',
      deptNames: [],
      url: '',
      windowWidth: window.innerWidth,
      // [2026-08-24] 상세 필터 접기 상태. 기본은 접힘 — 목록이 먼저 보이는 게 이 화면의 목적이다.
      showAdvancedFilter: false,
      // 목록 요약 통계. loaded 가 false 인 동안에는 칩을 아예 그리지 않아 0 이 잠깐 스쳐 보이지 않게 한다.
      stats: {
        loaded: false,
        byStatus: {},
        thisMonth: null,
        byContractType: [],
      },
      searchFilter: {
        startAt: null,
        endAt: null,
        startContractDate: null,
        endContractDate: null,
        selectedDateFilter: 'all',
        dateFilters: [3, 12, 36, 'etc'],
        selectedDateFilterForContractDate: 'all',
        dateFiltersForContractDate: [3, 12, 36, 'etc'],
        status: '',
        contractStatusList: [
          // 상태값: https://docs.google.com/spreadsheets/d/1R5YOeEJcEWyyYJO9Kgs6A2_GquosKHz8d3kauVidg-0/edit?usp=sharing
          {status: '', label: '전체'},
          // 중립 어휘 — 백엔드가 프로바이더별 원시 상태로 역매핑해 검색한다
          {status: 'SIGNING', label: '서명 진행중'},
          {status: 'COMPLETED', label: '모든 서명 완료'},
          {status: 'CANCELED', label: '서명 중단됨'},
          {status: 'EXPIRED', label: '기한 만료'},
          // {status: 'ON_PROCESSING', label: '문서 처리 중'},
          // {status: 'PROCESSING_FAILED', label: '문서 처리 실패'},
        ],
        contractGroup: '',
        contractSubGroup: "",
        contractSubGroupList: [
          // 덴티움
          {companyId: process.env.VUE_APP_DENTIUM_ID, deptName: "", contractSubGroup: '', label: '전체'},
          {companyId: process.env.VUE_APP_DENTIUM_ID, deptName: "장비", contractSubGroup: ContractTypeEnum.UnitChair, label: ContractTypeEnum.UnitChair},
          {companyId: process.env.VUE_APP_DENTIUM_ID, deptName: "장비", contractSubGroup: ContractTypeEnum.CADCAM, label: ContractTypeEnum.CADCAM},
          {companyId: process.env.VUE_APP_DENTIUM_ID, deptName: "장비", contractSubGroup: ContractTypeEnum.CT매매, label: ContractTypeEnum.CT매매},
          {companyId: process.env.VUE_APP_DENTIUM_ID, deptName: "장비", contractSubGroup: ContractTypeEnum.서비스로봇, label: ContractTypeEnum.서비스로봇},
          {companyId: process.env.VUE_APP_DENTIUM_ID, deptName: "장비", contractSubGroup: ContractTypeEnum.IOX, label: ContractTypeEnum.IOX},
          {companyId: process.env.VUE_APP_DENTIUM_ID, deptName: "장비", contractSubGroup: ContractTypeEnum.ICTMotor, label: ContractTypeEnum.ICTMotor},
          {companyId: process.env.VUE_APP_DENTIUM_ID, deptName: "장비", contractSubGroup: ContractTypeEnum.BrightXray, label: ContractTypeEnum.BrightXray},
          {companyId: process.env.VUE_APP_DENTIUM_ID, deptName: "영업", contractSubGroup: ContractTypeEnum.물품매매, label: ContractTypeEnum.물품매매},
          {companyId: process.env.VUE_APP_DENTIUM_ID, deptName: "영업", contractSubGroup: ContractTypeEnum.매출프로모션, label: ContractTypeEnum.매출프로모션},
          {companyId: process.env.VUE_APP_DENTIUM_ID, deptName: "영업", contractSubGroup: ContractTypeEnum.BNK, label: ContractTypeEnum.BNK},
          {companyId: process.env.VUE_APP_DENTIUM_ID, deptName: "영업", contractSubGroup: ContractTypeEnum.신협, label: ContractTypeEnum.신협},
          {
            companyId: process.env.VUE_APP_DENTIUM_ID,
            deptName: "고객지원",
            contractSubGroup: ContractTypeEnum.cbct설치확인서,
            label: ContractTypeEnum.cbct설치확인서
          },
          {
            companyId: process.env.VUE_APP_DENTIUM_ID,
            deptName: "고객지원",
            contractSubGroup: ContractTypeEnum.chair설치확인서,
            label: ContractTypeEnum.chair설치확인서
          },
          // 플라즈맵
          {companyId: process.env.VUE_APP_PLASMAPP_ID, contractSubGroup: '', label: '전체'},
          {companyId: process.env.VUE_APP_PLASMAPP_ID, contractSubGroup: ContractTypeEnum.ACTILINK, label: `${ContractTypeEnum.ACTILINK} Reborn`},
        ],
        deptName: ''
      },
      isCheckboxVisible: false,
      columns: columns,
      paginationData: {
        listSize: 0,
        rowsPerPage: 10,
        currentPage: 1,
        totalPages: 0,
      },
      contract: {
        list: [],
        totalDocs: 0,
      },
      loadingAnimation,
      successAnimation,
      isDentium: false,
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.uiHandler.updateWindowWidth);
  },
  async mounted() {
    // 다른 초기 로딩을 막지 않도록 기다리지 않는다. 응답을 못 받으면 도입 전 명단으로 판단한다(capabilities.js).
    fetchContractViewCapabilities().then((c) => { this.capabilities = c; });
    await this.uiHandler.checkIsDentium();
    await this.uiHandler.checkIsPointImplant();
    await this.uiHandler.updateWindowWidth();
    window.addEventListener('resize', this.uiHandler.updateWindowWidth);
    const statusQueryParamValue = this.$route.query.status;
    const contractGroupQueryParamValue = this.$route.query.contractGroup;
    const monthDateQueryParamValue = this.$route.query.monthDate;
    const dayDateQueryParamValue = this.$route.query.dayDate;
    const branchQueryParamValue = this.$route.query.branch;
    if (contractGroupQueryParamValue) {
      this.searchFilter.contractGroup = contractGroupQueryParamValue
    } else if (monthDateQueryParamValue) {
      this.searchFilter.selectedDateFilterForContractDate = 'etc';
      let year = dayjs().format("YYYY");
      let month = monthDateQueryParamValue;
      this.searchFilter.startContractDate = dayjs(`${year}-${month}-` + dayjs(`${year}-${month}`).startOf('month').format("DD")).valueOf();
      this.searchFilter.endContractDate = dayjs(`${year}-${month}-` + dayjs(`${year}-${month}`).endOf('month').format("DD")).valueOf();
      this.dateRangesForContractDate[0] = dayjs(this.searchFilter.startContractDate)
      this.dateRangesForContractDate[1] = dayjs(this.searchFilter.endContractDate)
    } else if (dayDateQueryParamValue) {
      this.searchFilter.selectedDateFilterForContractDate = 'etc';
      let date = dayDateQueryParamValue;
      this.searchFilter.startContractDate = dayjs(`${date}`).valueOf();
      this.searchFilter.endContractDate = dayjs(`${date}`).valueOf();
      this.dateRangesForContractDate[0] = dayjs(this.searchFilter.startContractDate)
      this.dateRangesForContractDate[1] = dayjs(this.searchFilter.endContractDate)
    } else if (branchQueryParamValue) {
      this.searchFilter.deptName = branchQueryParamValue
    }
    if (statusQueryParamValue) {
      this.searchFilter.status = statusQueryParamValue
    }
    this.uiHandler.pushRestColumn();
    await this.uiHandler.init();
  },
  methods: {
    ui() {
      const pushRestColumn = () => {
        console.log('1234',this.isMobile)
        const col =  {key: 'additional-func', title: '부가기능', dataIndex: 'additional-func', align: 'center'};
        if(!this.isMobile) this.columns.push(col)
        const col2 = {
          key: 'view-contract', title: '계약서 보기', dataIndex: 'view-contract', align: 'center',
          customRender: ({record}) => {
            return (
                <div onClick={() => this.uiHandler.fileDownload(record)}
                    style={{cursor: 'pointer', display: "flex", alignItems: 'left'}}>
                  <img src={require('@/assets/img/pdf-icon.svg')} alt="pdf logo"/>
                  <a-tooltip placement="top">
                    <a-typography-text ellipsis style={{width: '90px'}}>
                      {record.title}
                    </a-typography-text>
                  </a-tooltip>
                </div>
            );
          },
        }
        this.columns.push(col2)
      }
      const receiveExpirationDate = async (contractIdAndDate) => {
        const params = {};
        params.contractId = contractIdAndDate.contractId;
        params.date = contractIdAndDate.date;
        await changeSigningDue(params);
      }
      const updateWindowWidth = async () => {
        this.windowWidth = window.innerWidth;
      }

      const changeSigningDue = async (contractObj) => {
        await this.apiHandler.changeSigningDue(
            contractObj,
            async (response) => {
              logging().exceptProd(response);
              await oneBtnDialog('만료 기한 변경 성공', '만료 기한 변경에 성공하였습니다.', true);
              $('#contract-expiration-modal').modal('hide');
            },
            async (error) => {
              logging().exceptProd(error)
              await oneBtnDialog('만료 기한 변경 실패', '만료 기한 변경에 실패하였습니다.', false);
            }
        );
      }

      const convertMonthAndYearText = (input) => {
        if (input < 12) return `${input}${this.$i18n.t('common_searchfilter_month')}`;
        return `${input / 12}${this.$i18n.t('common_searchfilter_year')}`;
      };
      const handleDateFilter = (value) => {
        this.paginationData.currentPage = 1;
        if (value === this.searchFilter.selectedDateFilter) return;

        this.searchFilter.selectedDateFilter = value;

        if (value === 'all') {
          this.searchFilter.startAt = null;
          this.searchFilter.endAt = null;
        } else {
          this.searchFilter.startAt = this.uiHandler.getPastDatesInUnixTime(value);
          this.searchFilter.endAt = this.uiHandler.getCurrentUnixTime();
        }
        if (this.searchFilter.startAt !== null) {
          this.dateRanges[0] = dayjs(this.searchFilter.startAt)
        } else {
          this.dateRanges = [];
        }
        if (this.searchFilter.endAt !== null) {
          this.dateRanges[1] = dayjs(this.searchFilter.endAt)
        } else {
          this.dateRanges = [];
        }
        this.uiHandler.search({startAt: this.searchFilter.startAt, endAt: this.searchFilter.endAt});
      };
      const handleDateFilterForContractDate = (value) => {
        this.paginationData.currentPage = 1;
        if (value === this.searchFilter.selectedDateFilterForContractDate) return;

        this.searchFilter.selectedDateFilterForContractDate = value;

        if (value === 'all') {
          this.searchFilter.startContractDate = null;
          this.searchFilter.endContractDate = null;
        } else {
          this.searchFilter.startContractDate = this.uiHandler.getPastDatesInUnixTime(value);
          this.searchFilter.endContractDate = this.uiHandler.getCurrentUnixTime();
        }
        if (this.searchFilter.startContractDate !== null) {
          this.dateRangesForContractDate[0] = dayjs(this.searchFilter.startContractDate)
        } else {
          this.dateRangesForContractDate = [];
        }
        if (this.searchFilter.endContractDate !== null) {
          this.dateRangesForContractDate[1] = dayjs(this.searchFilter.endContractDate)
        } else {
          this.dateRangesForContractDate = [];
        }
        this.uiHandler.search({
          startContractDate: this.searchFilter.startContractDate,
          endContractDate: this.searchFilter.endContractDate
        });
      };
      const getCurrentUnixTime = () => {
        return dayjs().valueOf();
      };
      const applySearchFilters = (params) => {
        // ui 에서 입력한 값을 조건에 맞게 data 변수에 바인딩하는 용도 (⚠️ getSearchFilter 와 구분)
        if (this.searchFilter.keyword) {
          logging().exceptProd('keyword===>', this.searchFilter.keyword)
          if (this.keywordOption === '계약명') {
            this.searchFilter.title = this.searchFilter.keyword;
            this.searchFilter.deptName = '';
            this.searchFilter.custNo = '';
          } else if (this.keywordOption === '부서/지점') {
            this.searchFilter.title = '';
            this.searchFilter.deptName = this.searchFilter.keyword;
            this.searchFilter.custNo = '';
          } else if (this.keywordOption === '거래처번호') {
            this.searchFilter.title = '';
            this.searchFilter.deptName = '';
            this.searchFilter.custNo = this.searchFilter.keyword;
          }
        } else {
          this.searchFilter.title = '';
          this.searchFilter.deptName = '';
          this.searchFilter.custNo = '';
        }

        if (this.dateRanges?.length == 2) {
          this.searchFilter.startAt = this.dateRanges[0]?.valueOf()
          this.searchFilter.endAt = this.dateRanges[1]?.valueOf()
        } else {
          this.searchFilter.startAt = null
          this.searchFilter.endAt = null
        }

        if (this.dateRangesForContractDate?.length == 2) {
          this.searchFilter.startContractDate = this.dateRangesForContractDate[0]?.valueOf()
          this.searchFilter.endContractDate = this.dateRangesForContractDate[1]?.valueOf()
        } else {
          this.searchFilter.startContractDate = null
          this.searchFilter.endContractDate = null
        }

        // 계약상태 파라미터 매핑
        if (params.status) this.searchFilter.status = params.status;
        // 계약분류 파라미터 매핑
        if (params.contractSubGroup) this.searchFilter.contractSubGroup = params.contractSubGroup;
      }
      const getSearchFilter = () => {
        // data 변수를 api 전송포맷에 맞게 변환하는 함수 (⚠️ applySearchFilters 와 구분)
        const obj = {...this.searchFilter};
        const params = {};
        if (obj.title && obj.title !== '') params.title = obj.title;
        if (obj.deptName && obj.deptName !== '') params.deptName = obj.deptName;
        if (obj.custNo && obj.custNo !== '') params.custNo = obj.custNo;
        if (obj.startAt) params.createStartAt = this.uiHandler.unixTimeToYYYYMMDD(obj.startAt);
        if (obj.endAt) params.createEndAt = this.uiHandler.unixTimeToYYYYMMDD(obj.endAt);
        if (obj.startContractDate) params.startContractDate = this.uiHandler.unixTimeToYYYYMMDD(obj.startContractDate);
        if (obj.endContractDate) params.endContractDate = this.uiHandler.unixTimeToYYYYMMDD(obj.endContractDate);
        if (obj.status && obj.status !== '') params.status = obj.status;
        if (obj.contractGroup && obj.contractGroup !== '') params.contractGroup = obj.contractGroup;
        if (obj.contractSubGroup && obj.contractSubGroup !== '') params.contractSubGroup = obj.contractSubGroup;
        const metadatas = {};
        // companyId는 서버가 JWT 값으로 강제 대체하므로 여기서 보내는 값은 조회 조건에 쓰이지 않는다.
        // 자기 토큰 값을 그대로 전달한다 (타사 companyId를 주입하지 말 것)
        metadatas.companyId = jwtDecoder(getAccessToken())
        metadatas.contractCreator = this.contractCreator;

        params.metadatas = metadatas;
        params.page = this.paginationData.currentPage;
        params.limit = this.paginationData.rowsPerPage;

        return params;
      }
      const getPastDatesInUnixTime = (value) => {
        switch (value) {
          case 3:
            return dayjs().subtract(3, 'month').valueOf();
          case 12:
            return dayjs().subtract(12, 'month').valueOf();
          case 36:
            return dayjs().subtract(36, 'month').valueOf();
          default:
            return dayjs().valueOf();
        }
      }
      const unixTimeToYYYYMMDD = (unixTime) => {
        return dayjs(unixTime).format('YYYYMMDD');
      }
      const convertSignMethod = (val) => {
        switch (val) {
          case ModuSignMethod.KAKAO:
            return '카카오톡';
          case ModuSignMethod.SECURE_LINK:
            return '대면서명';
          case CustomeSignMethod.DON_NEED_SIGN_ABORTED:
            return '-';
          case CustomeSignMethod.DON_NEED_SIGN_COMPLETED:
            return '완료';
          default:
            return '서명 대기자 없음';
        }
      }

      const routeToContractType = () => {
        // 「신규 계약」은 버전 없는 고정 주소(/contract/types)로 보낸다 — 라우터 alias 가 현재 창구의
        // 유형 선택 화면에 연결한다. 창구를 옮겨도 이 화면은 고칠 것이 없다(utils/contractConsole.js).
        // v5 create 화면이 아직 없어 카드 클릭 시엔 여전히 v1 create 라우트로 가지만, "신규 계약"
        // 버튼 자체는 v5 목록 화면 소유이므로 v5 유형 선택 화면을 거치도록 바꾼다.
        this.$router.push(CONTRACT_TYPES_PATH)
      }

      return {
        reload: () => window.location.reload(),
        init: async () => {
          const data = JSON.parse(getProfile(localStorageEnums.CompanyInfo));
          this.contractCreator = data?.accountInfo?.username;
          await this.uiHandler.loadDeptNames();
          await this.apiHandler.getContracts(
              getSearchFilter(),
              (response) => {
                this.paginationData.totalPages = response.data.totalPages;
                this.contract.list = response.data.docs;
                this.contract.totalDocs = response.data.totalDocs;
                for (let i = 0; i < this.contract.list.length; i++) {
                  const item = this.contract.list[i];
                  item.index = this.contract.totalDocs - (this.paginationData.currentPage - 1) * this.paginationData.rowsPerPage - i;
                  // item.contractManager = item.participants[0]?.name;
                  // item.managerOfClient = item.participants[1]?.name;
                }
              },
              async (error) => {
                logging().exceptProd('getContracts fail==>', error)
                this.$store.commit('setIsLoading', false);
                await oneBtnDialog('목록 로드 오류', '계약서 목록 로드에 실패했습니다.', false);
              }
          )
          // 목록과 같은 조건으로 요약 통계도 갱신한다(2026-08-24)
          await this.uiHandler.refreshStats();
        },
        loadDeptNames: async () => {
          if (this.isDentium) {
            await this.apiHandler.getDistinctDeptName({}, (deptNames) => {
              this.deptNames = deptNames;
            }, (error) => {
              console.error('Failed to load department names', error);
            });
          }
        },
        initSearchFilter: () => {
          this.searchFilter = {
            startAt: null,
            endAt: null,
            startContractDate: null,
            endContractDate: null,
            selectedDateFilter: 'all',
            dateFilters: [3, 12, 36, 'etc'],
            selectedDateFilterForContractDate: 'all',
            dateFiltersForContractDate: [3, 12, 36, 'etc'],
            status: '',
            contractStatusList: [
              // 상태값: https://docs.google.com/spreadsheets/d/1R5YOeEJcEWyyYJO9Kgs6A2_GquosKHz8d3kauVidg-0/edit?usp=sharing
              {status: '', label: '전체'},
              // 중립 어휘 — 백엔드가 프로바이더별 원시 상태로 역매핑해 검색한다
              {status: 'SIGNING', label: '서명 진행중'},
              {status: 'COMPLETED', label: '모든 서명 완료'},
              {status: 'CANCELED', label: '서명 중단됨'},
              {status: 'EXPIRED', label: '기한 만료'},
          {status: 'EXPIRED', label: '기한 만료'},
              // {status: 'ON_PROCESSING', label: '문서 처리 중'},
              // {status: 'PROCESSING_FAILED', label: '문서 처리 실패'},
            ],
            contractSubGroup: '',
            contractSubGroupList: this.contractTypeListByManufacturer,
            deptName: ''
          }
        },
        clientSyncVisible: (record) => {
          if (process.env.VUE_APP_DENTIUM_ID === record.companyId) {
            return !record.custNo && this.isDentiumAdmin
          } else if (process.env.VUE_APP_PLASMAPP_ID === record.companyId) {
            // 거래처 동기화 버튼이 필요한지 체크해야함
            // return this.isPlasmappAdmin
            return false
          } else {
            return false
          }
        },
        handleModal: {
          client: {
            show: (currentContractId) => {
              this.currentContractId = currentContractId;
              this.modal.client.show = true;
            },
            close: () => this.modal.client.show = false,
            handleEvent: {
              selectClient: async (client) => {
                await this.apiHandler.syncClient({
                  "contractId": this.currentContractId,
                  "cNo": client.cNo
                }, async () => {
                  await this.uiHandler.search(this.searchFilter)
                  await oneBtnDialog('알림', '거래처가 동기화 되었습니다.')
                });

                this.modal.client.show = false;
              }
            }
          }
        },
        deleteContracts: async () => {
          const params = this.contract.list.filter(d => d.isChecked).map(d => d.contractId);
          if (params.length < 1) {
            await oneBtnDialog('알림', `삭제할 계약을 선택해주세요.`)
            return
          }

          const isConfirmed = await twoBtnDialog(`계약서 삭제`, `선택한 계약서를 삭제하시겠습니까? 삭제한 계약서는 복구할 수 없습니다.`, '삭제');
          if (!isConfirmed) return;
          await this.apiHandler.deleteContracts(params, async () => {
            await oneBtnDialog('알림', `${params.length}건의 계약이 삭제되었습니다.`).then(async () => {
              this.isCheckboxVisible = false;
              this.columns = this.columns.filter(column => column.key !== 'selection');
              await this.uiHandler.init();
            })
          }, () => {
            oneBtnDialog('알림', `${params.length}건의 계약 삭제에 실패하였습니다.`)
          })
        },
        toggleCheckboxColumn: () => {
          this.isCheckboxVisible = !this.isCheckboxVisible;

          if (this.isCheckboxVisible) {
            // 선택 컬럼 추가
            const selectionColumn = {
              title: () => {
                const deleteCount = this.contract.list.filter(item => item.isChecked).length
                return (
                    <div>
                      <span>{deleteCount}개 선택됨</span><br/>
                      <a-checkbox style={{cursor: "pointer", marginLeft: '8px'}}
                                  onChange={(e) => {
                                    const checkValue = e.target.checked;
                                    this.contract.list.forEach(item => {
                                      item.isChecked = checkValue;
                                    });
                                  }
                                  }></a-checkbox>
                    </div>
                );
              },
              key: 'selection',
              width: 60,
              customRender: ({record}) => {
                return <a-checkbox checked={record.isChecked}
                                   onChange={(e) => record.isChecked = e.target.checked}></a-checkbox>;
              },
              align: 'center'
            };
            this.columns = [selectionColumn, ...this.columns]; // 선택 컬럼을 목록의 맨 앞에 추가
          } else {
            // 선택 컬럼 제거
            this.columns = this.columns.filter(column => column.key !== 'selection');
          }
        },
        search: async (params) => {
          this.isCheckboxVisible = false;
          this.columns = this.columns.filter(column => column.key !== 'selection');
          applySearchFilters(params);

          // 조회
          this.paginationData.currentPage = 1;
          await this.apiHandler.getContracts(
              getSearchFilter(),
              (response) => {
                this.contract.list = response.data.docs;
                this.contract.totalDocs = response.data.totalDocs;
                this.paginationData.totalPages = response.data.totalPages;
                for (let i = 0; i < this.contract.list.length; i++) {
                  const item = this.contract.list[i];
                  item.index = this.contract.totalDocs - (this.paginationData.currentPage - 1) * this.paginationData.rowsPerPage - i;
                  // item.contractManager = item.participants[0]?.name;
                  // item.managerOfClient = item.participants[1]?.name;
                }
                this.$store.commit('setIsLoading', false);
              },
              (error) => {
                logging().exceptProd('getContracts fail==>', error)
                this.$store.commit('setIsLoading', false);
              }
          );
          // 목록과 같은 조건으로 요약 통계도 갱신한다(2026-08-24)
          await this.uiHandler.refreshStats();
        },
        /**
         * 목록 요약 통계 갱신 — 목록 조회와 **같은 필터**로 부른다.
         * 실패해도 목록은 그대로 보이게 조용히 넘긴다(보조 정보라 화면을 막지 않는다).
         */
        refreshStats: async () => {
          await this.apiHandler.getContractStats(
              getSearchFilter(),
              (response) => {
                const d = response?.data ?? {};
                this.stats = {
                  loaded: true,
                  byStatus: d.byStatus ?? {},
                  thisMonth: typeof d.thisMonth === 'number' ? d.thisMonth : null,
                  byContractType: d.byContractType ?? [],
                };
              },
              (error) => {
                logging().exceptProd('getContractStats fail==>', error);
                // 통계만 못 받은 것이므로 칩을 감추고 목록은 유지한다
                this.stats = {loaded: false, byStatus: {}, thisMonth: null, byContractType: []};
              },
          );
        },
        /** 상태 칩 클릭 — 같은 칩을 다시 누르면 해제(토글). 필터를 찾아 내려갈 필요를 없앤다. */
        applyStatusChip: async (status) => {
          const next = this.searchFilter.status === status ? '' : status;
          this.searchFilter.status = next;
          await this.uiHandler.search({status: next});
        },
        fileDownload: async (record) => {
          const contractId = record.contractId;
          await this.apiHandler.getContract(
              contractId,
              true,
              async (response) => {
                this.$store.commit('setIsLoading', false);
                // [2026-08-24] 프릭스 계약은 S3 presigned URL 이 octet-stream 이라 그대로 열면
                // 브라우저가 뷰어 대신 **다운로드**를 시작한다(운영 실측). 모두싸인은 새 탭 열람이라
                // 동작이 갈리므로, 프릭스만 contracts-api 의 inline 프록시로 연다.
                // 판정은 백엔드가 실어 보내는 serviceProvider 로 한다 — URL 호스트 문자열로 추측하면
                // 프릭스가 주소를 바꿀 때 조용히 깨진다.
                if (response.data?.serviceProvider === 'PRIX') {
                  // [2026-09-04] 프릭스는 **체결 전에는 빈 원본 서식**을 준다(값·날인은 체결 후
                  // concludedFile 에만 들어간다). 그래서 진행중 계약을 그대로 프록시하면 입력값이
                  // 하나도 없는 계약서가 열려, 영업사원이 데이터 소실로 오인하고 멀쩡한 계약을
                  // 취소한다(사랑치과·신원치과 실측).
                  //
                  // `/preview` 가 서버에서 갈라 준다 — 진행중이면 값이 채워진 미리보기(iframe 껍데기),
                  // 그 외에는 `/document` 로 리다이렉트. 화면은 분기를 몰라도 된다.
                  //
                  // [HARD] 여기서 **await 를 두지 않는다.** 클릭과 window.open 사이에 비동기가
                  // 끼면 브라우저가 사용자 제스처와의 연결을 잃어 팝업으로 차단한다. 판정은
                  // 서버가 하므로 URL 을 미리 알 필요가 없다.
                  window.open(`${process.env.VUE_APP_CONTRACTS_API_URL}/contracts/${contractId}/preview`);
                  return;
                }
                if (response.data?.file?.downloadUrl) {
                  window.open(response?.data?.file?.downloadUrl);
                }
              },
              (error) => {
                logging().exceptProd('getContracts fail==>', error);
                this.$store.commit('setIsLoading', false);
                oneBtnDialog('다운로드 오류', '파일 다운로드에 실패했습니다.', false);
              }
          );
        },
        updateWindowWidth,
        handleDateFilterForContractDate,
        handleDateFilter,
        getCurrentUnixTime,
        getPastDatesInUnixTime,
        unixTimeToYYYYMMDD,
        pushRestColumn,
        convertMonthAndYearText,
        paginationHandler: async (childPassParam) => {
          this.isCheckboxVisible = false;
          this.columns = this.columns.filter(column => column.key !== 'selection');

          this.paginationData.currentPage = childPassParam.page;
          await this.apiHandler.getContracts(
              getSearchFilter(),
              (response) => {
                this.contract.list = response.data.docs;
                this.contract.totalDocs = response.data.totalDocs;
                this.paginationData.totalPages = response.data.totalPages;
                for (let i = 0; i < this.contract.list.length; i++) {
                  const item = this.contract.list[i];
                  item.index = this.contract.totalDocs - (this.paginationData.currentPage - 1) * this.paginationData.rowsPerPage - i;
                  // item.contractManager = item.participants[0]?.name;
                  // item.managerOfClient = item.participants[1]?.name;
                }
                this.$store.commit('setIsLoading', false);
              },
              (error) => {
                logging().exceptProd('getContracts fail==>', error)
                this.$store.commit('setIsLoading', false);
              }
          );
          // 목록과 같은 조건으로 요약 통계도 갱신한다(2026-08-24)
          await this.uiHandler.refreshStats();
        },
        getSearchFilter,
        convertProgressClass: (input, signingParty) => {
          switch (input) {
              // 중립 계약서 상태 (프로바이더 무관 — 백엔드가 중립 어휘로 내려준다)
            case 'SIGNING':
              return signingParty === 'MANUFACTURER' ? 'dentium_green' : 'orange';
            case 'COMPLETED':
              return 'green';
            case 'CANCELED':
              return 'red';
            case 'EXPIRED':
              return 'gray';
            case 'PROCESSING':
              return 'gray';
            case 'UNKNOWN':
              return 'gray';
              // 서명방식
            case ModuSignMethod.KAKAO:
              return 'orange';
            case ModuSignMethod.SECURE_LINK:
              return 'blue';
            case CustomeSignMethod.DON_NEED_SIGN_COMPLETED:
              return 'gray'
            case CustomeSignMethod.DON_NEED_SIGN_ABORTED:
              return ''
            default:
              return 'd-none';
          }
        },
        convertProgressMessage: (input, signingParty) => {
          switch (input) {
            case 'SIGNING':
              return signingParty === 'MANUFACTURER' ? '덴티움 서명 진행중' : '거래처 서명 진행중';
            case 'COMPLETED':
              return '모든 서명 완료';
            case 'CANCELED':
              return '서명 중단됨';
            case 'EXPIRED':
              return '기한 만료';
            case 'PROCESSING':
              return '문서 처리 중';
            // [2026-08-24] convertProgressClass 에는 UNKNOWN(회색)이 있는데 여기에만 없어
            // 회색 태그에 '-' 만 찍혔다. UNKNOWN 은 프로바이더가 새 원시 상태를 추가했을 때
            // 나오는 fail-safe 값이다(neutral-contract-status.ts) — 배치가 재조회하므로
            // '확인 중'으로 표기한다.
            case 'UNKNOWN':
              return '상태 확인 중';
            default:
              return '-';
          }
        },
        convertSignMethod,
        routeToContractType,
        checkIsDentium: () => {
          const companyId = jwtDecoder(getAccessToken());
          if (companyId && companyId === process.env.VUE_APP_DENTIUM_ID) {
            this.isDentium = true;
          }
        },
        checkIsPointImplant: () => {
          const companyId = jwtDecoder(getAccessToken());
          if (companyId && companyId === process.env.VUE_APP_POINT_IMPLANT) {
            this.isDentium = true; // todo 임시로 사용 추후 isPointImplant 변수 필요함
          }
        },
        getManagerInfo: (item) => {
          logging().exceptProd('managerinfo => ', item)
          const mobile = item.mobile;
          if (!item.email) return mobile;
          return `${mobile} / ${item.email}`;
        },
        receiveExpirationDate,
        currentSignMethod(item) {
          return {
            isKakao: item?.currentParticipant?.signingMethod?.type === ModuSignMethod.KAKAO,
            isSecureLink: item?.currentParticipant?.signingMethod?.type === ModuSignMethod.SECURE_LINK,
            isAborted: item?.currentParticipant?.signingMethod?.type === CustomeSignMethod.DON_NEED_SIGN_ABORTED
          }
        },
        additionalFunc: {
          selectContract: (record) => {
            this.selectedContract = record;
          },
          cancelContract: async (record) => {
            const isConfirmed = await twoBtnDialog(`서명 요청 취소`, `서명 요청을 취소 하시겠습니까?`, '확인');
            if (!isConfirmed) return;

            await this.apiHandler.cancelContract(record.contractId, async (response) => {
              await oneBtnDialog('서명 요청 취소 성공', '서명 요청을 취소 하였습니다.', true);
            }, async (error) => {
              logging().exceptProd(error);
              await oneBtnDialog('서명 요청 취소 실패', '서명 요청 취소하지 못 했습니다.', false);
            })
          },
          sendCompleteContract: async (record) => {
            const isConfirmed = await twoBtnDialog(`완료된 계약서 재전송`, `거래처 담당자에게 완료된 계약서를 재전송 하시겠습니까?`, '확인');
            if (!isConfirmed) return;

            const {clients} = record
            await this.apiHandler.sendCompleteContract({
              contractId: record.contractId,
              contactList: clients.map(c => c?.mobile.replaceAll("-", ''))
            }, async (response) => {
              this.$store.commit('setIsLoading', false);
              await oneBtnDialog('완료된 계약서 재전송 성공', '완료된 계약서를 재전송 하였습니다.', false);
            }, async (error) => {
              this.$store.commit('setIsLoading', false);
              logging().exceptProd(error);
              await oneBtnDialog('완료된 계약서 재전송 실패', '완료된 계약서를 재전송 하지 못했습니다.', false);
            })
          },
          resendRequest: async (record) => {
            const dialogMsg = {
              title: '서명 요청 재전송',
              txt: '서명 요청 알림을 다시 보내시겠습니까?'
            }
            if (this.uiHandler.currentSignMethod(record).isSecureLink) {
              dialogMsg.title = '계약서 서명'
              dialogMsg.txt = '계약서 서명을 진행하시겠습니까?'
            }
            const isConfirmed = await twoBtnDialog(dialogMsg.title, dialogMsg.txt, '확인');
            if (!isConfirmed) return;

            const {participants} = record
            logging().exceptProd("1.contract==>", record)
            const contractId = record.contractId;
            // 중립 계약: 현재 차례 참여자는 백엔드(currentParticipant)가 프로바이더 무관하게 내려준다
            const participant = record.currentParticipant?.id ? record.currentParticipant : participants[0]
            const signMethod = participant?.signingMethod?.type

            if (signMethod === ModuSignMethod.KAKAO) {
              console.log('kakao')
              await this.apiHandler.resendRequest(
                  contractId,
                  async (response) => {
                    logging().exceptProd('서명 요청 재전송==>', response)
                    await oneBtnDialog('서명 요청 재전송 성공', '서명 요청 재전송에 성공하였습니다.', false);
                  },
                  async (error) => {
                    logging().exceptProd(error);
                    await oneBtnDialog('서명 요청 재전송 실패', '서명 요청 재전송에 실패하였습니다.', false);
                  }
              )
            } else if (signMethod === 'SECURE_LINK') {
              await this.apiHandler.sendSecureSignLink({
                    contractId,
                    participantId: participant.id,
                    isWeb: true
                  },
                  async (response) => {
                    this.$store.commit('setIsLoading', false);
                    if (response) {
                      window.open(response?.data?.embeddedUrl);
                    }
                  }, async (error) => {
                    this.$store.commit('setIsLoading', false);
                    await oneBtnDialog('fail', JSON.stringify(error))
                  })
            }
          }
        },
        awaitForUrl: async (url) => {
          if (!url) return;
          this.url = url;
        },
        fetchContractsExcel: async () => {
          if (this.contract.list.length === 0) {
            await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), this.$i18n.t('certificatelist_list_empty_content'), false);
            return;
          }

          await this.apiHandler.fetchContractsExcel(
              getSearchFilter(),
              (response) => {
                return;
              },
              async (error) => {
                console.error('error: ', error);
                if (error.response && error.response.status === 404) {
                  if (error.response.data instanceof Blob) {
                    const reader = new FileReader();
                    reader.readAsText(error.response.data);
                    reader.onload = async () => {
                      try {
                        const errorData = JSON.parse(reader.result);
                        await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), errorData.message, false);
                      } catch {
                        await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), this.$i18n.t('certificatelist_list_excel_error'), false);
                      }
                    };
                    reader.onerror = async () => {
                      await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), this.$i18n.t('certificatelist_list_excel_error'), false);
                    };
                  } else {
                    await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), this.$i18n.t('certificatelist_list_excel_error'), false);
                  }
                } else {
                  await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), this.$i18n.t('certificatelist_list_excel_error'), false);
                }
              }
          )
        },
        fetchContractsPdfDownload: (params) => {
          if (this.contract.totalDocs > 500) {
            oneBtnDialog("안내", "최대 한번에 500개 까지 다운로드 가능합니다.")
            return
          }

          applySearchFilters(params);

          this.pdfDownloadProgressbarVisible = true;
          this.pdfDownloadProgressPercentage = 1; // 초기값 설정

          let intervalId = setInterval(() => {
            if (this.pdfDownloadProgressPercentage < 95) { // 95%까지 증가
              this.pdfDownloadProgressPercentage += 1;
            }
          }, 3000);

          this.searchFilter.startAt = this.dateRanges[0]?.valueOf();
          this.searchFilter.endAt = this.dateRanges[1]?.valueOf();

          // 조회
          this.paginationData.currentPage = 1;
          const currentRowsPerPage = this.paginationData.rowsPerPage;
          this.paginationData.rowsPerPage = 500;

          return this.apiHandler.getContractsPdfDownload(getSearchFilter(), async (response) => {
            this.paginationData.rowsPerPage = currentRowsPerPage;
            clearInterval(intervalId); // API 호출 완료 후 interval 제거

            // 응답에서 파일 다운로드 URL을 추출하고 처리
            const fileUrls = response.data; // 가정: response가 다운로드 URL의 배열을 반환
            const totalFiles = fileUrls.length;
            let downloadedFiles = 0;

            if (!Array.isArray(fileUrls)) {
              return await oneBtnDialog('파일 다운로드 실패', '파일 다운로드에 실패하였습니다.', false);
            }

            for (const u of fileUrls) {
              try {
                const fileResponse = await fetch(u.downloadUrl);

                const blob = await fileResponse.blob();
                const a = document.createElement('a');
                const url = window.URL.createObjectURL(blob);
                a.href = url;
                a.setAttribute('download', u.title);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);

                downloadedFiles += 1; // 다운로드된 파일 수 증가

                // 진행 상태 업데이트
                const remainingPercentage = 100 - this.pdfDownloadProgressPercentage;
                const increment = (downloadedFiles / totalFiles) * remainingPercentage;
                this.pdfDownloadProgressPercentage = parseInt((this.pdfDownloadProgressPercentage + increment).toFixed(2));
              } catch (error) {
                console.error(`Failed to download file from ${u}:`, error);
              }
            }
            setTimeout(() => {
              this.pdfDownloadProgressbarVisible = false; // 모든 다운로드가 완료된 후 진행 상태 표시줄 숨기기
            }, 3000);
          }, (error) => {
            clearInterval(intervalId); // 에러 발생 시 interval 제거
            console.error(error);
          });
        }
      }
    },
    api() {
      // v5: contracts-api 인스턴스 바인딩 (v1의 this.$apiInstance 대신 contractsApiInstance)
      return contractApi(contractsApiInstance, this.$store)
    },
  }
}
</script>
<style scoped>
.ant-btn-default:hover {
  color: #2F3337 !important;
}

.noData {
  color: #acb2b9;
  font-size: 16px;
  margin: 20px;
}

.titleContainer {
  margin-bottom: 30px;

  .title {
    font-size: 24px;
    font-weight: bold;
    color: #2F3337;
    line-height: 1.2;
    margin-bottom: 5px;
    letter-spacing: 0;
  }

  .desc {
    color: #6e747c;
    font-weight: 400;
  }
}

.extra-btn-wrap {
  display: flex;
  gap: 16px;
  padding: 0 10px;
  align-items: center;
  justify-content: center;
}
</style>
<style scoped lang="scss">
.search-filter-content {
  .mobile-wrap {
    display: flex;
    gap: 8px;
  }

  .mobile-no-wrap {
    display: flex;
  }
}

.flex-wrap {
  display: flex;
  gap: 8px;
}

/* [2026-08-25] 상세 필터 래퍼 — **공통**(미디어쿼리 밖)이어야 한다.
   부모 .search-filter-container 는 display:flex + nowrap + space-between 이고, 이 래퍼는
   .search-filter-row 들과 형제다. row 들은 width:100% 를 갖지만 이 래퍼만 폭 지정이 없으면
   콘텐츠 폭으로 줄어들고, space-between 이 그걸 오른쪽 끝으로 밀어낸다
   (PC 1730px 실측: row x=249 w=1452 인데 래퍼는 x=670 w=610 으로 쏠렸다).
   처음 넣을 때 모바일 미디어쿼리 안에만 두어 PC 에서 깨졌다 — 폭 지정은 화면 크기와 무관하다. */
.advanced-filter-body {
  width: 100%;
  min-width: 0; /* flex 아이템 기본값 auto 는 콘텐츠 폭만큼 부풀어 부모를 밀어낸다 */
}

/* [2026-08-25] 검색 박스 제목 줄 — 제목(좌) / 상세 조건 토글(우).
   부모 .search-filter-container 는 flex column 이라 이 줄도 width:100% 를 받아야
   space-between 이 양 끝으로 벌어진다. 폭·정렬 지정은 미디어쿼리 밖에 둔다 —
   모바일 블록 안에만 두었다가 PC 가 깨진 전례가 있다(08-25 상세필터 건). */
.search-header-row {
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.search-header-title {
  font-weight: 600;
  padding-left: 16px;
}

.advanced-toggle-btn {
  margin-right: 16px;
}

/* [2026-08-25] 액션 버튼(엑셀/PDF/신규/삭제/페이지크기) 우측 정렬 — V1 과 같은 배치라는
   QA 요청. 부모는 space-between 인데 통계 카드가 뜨면 .total-div 가 사라져 버튼 묶음만
   남고, 그러면 space-between 이 왼쪽에 붙인다. margin-left:auto 로 오른쪽 끝에 고정한다.
   [HARD] PC 전용이다 — 모바일에서는 .search-container 가 width:100% + wrap 이라
   우측 정렬을 걸면 줄바꿈된 버튼들이 오른쪽으로 쏠려 들쭉날쭉해진다(사용자 결정). */
@media screen and (min-width: 768px) {
  .table-with-search .table-info-filter .search-container {
    margin-left: auto;
  }
}

@media screen and (max-width: 767px) {
  .date-selector-container,
  .ant-picker.ant-picker-range {
    width: 100% !important;
  }
  /* [2026-08-24] 날짜 필터가 모바일에서 3 줄을 차지하던 원인 — 실측으로 확인한 구조:
     wrapper(column) 안에 `.date-filter-container` 가 **3 개** 쌓여 있고, 각 컨테이너 안의
     `.date-filter-item` 이 width:50% 로 2 등분돼 있었다(전체|3개월 / 1년|3년 / 기간설정).
     앞선 시도는 컨테이너 안쪽만 고쳐 효과가 없었다 — wrapper 자체를 한 줄로 눕힌다.
     세 번째 컨테이너에는 인라인 `style="width:100%"` 가 있어 !important 로만 이길 수 있다. */
  .search-filter-content .date-filter-container-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    width: 100%;
    gap: 0;

    &::-webkit-scrollbar {
      height: 0;
    }

    .date-filter-container {
      flex: 0 0 auto;
      width: auto !important;   /* 인라인 width:100% 를 이긴다 */
      flex-direction: row;
      flex-wrap: nowrap;
      border-radius: 0;
      border-bottom: 0;

      .date-filter-item {
        flex: 0 0 auto;
        width: auto;
        padding: 0 12px;
        white-space: nowrap;
        border-bottom: 0;
      }
    }
  }

  /* 필터 내용이 가운데로 몰려 통계 카드보다 좁아 보이던 것 — 폭을 채우고 좌측 정렬한다.
     min-width: 0 이 핵심이다: flex 아이템의 기본 min-width:auto 때문에 날짜 필터(447px)가
     컨테이너(390px)를 **밀어내** 필터 영역 전체가 좌측으로 잘려 보였다(실측).
     0 으로 낮추면 넘치는 부분은 wrapper 안에서만 가로 스크롤된다. */
  .search-filter-content {
    width: 100%;
    min-width: 0;
    align-items: flex-start;
    overflow: hidden;
  }

  .search-filter-row {
    min-width: 0;
  }

  .search-filter-content .date-filter-container-wrapper {
    max-width: 100%;
  }

  .search-filter-title {
    text-align: left;
    justify-content: flex-start;
  }
  .container-fluid .row.justify-content-center {
    padding: 14px 14px 36px 14px !important;
  }
  .mainDiv {
    width: 100% !important;
  }
  .search-filter-title {
    margin-right: auto;
    width: auto;
    margin-left: 10px;
  }
  .search-filter-content .mobile-wrap {
    width: 100%;
  }
  .search-filter-content .search-select {
    width: 100px;
  }
  .search-filter-content .search-input-container {
    width: calc(100% - 100px);
    display: flex;
    justify-content: flex-start;

    input {
      width: 100%;
    }
  }
  .search-filter-content .date-filter-container {
    height: auto;
  }
  .search-filter-content .date-selector-container.custom {
    flex-direction: column;
    height: auto;
    align-items: center;
  }
  .search-filter-content .date-filter-container {
    flex-direction: column;
  }
  .search-filter-row {
    height: auto;
  }
  .search-filter-row,
  .search-filter-content {
    flex-direction: column;
    flex: none;
  }
  .card-header {
    margin: 0;
  }
  /* 엑셀/PDF/신규계약/삭제/페이지크기가 한 줄에 안 들어가 화면 밖으로 나갔다 — 줄바꿈시킨다 */
  .search-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 6px;
    width: 100%;
  }

  .search-container > * {
    flex: 0 0 auto;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .search-filter-title {
    width: 100%;
    justify-content: flex-start;
    margin-left: 20px;
  }
  .table-with-search .table-info-filter {
    flex-direction: column;
    width: 100%;

    .total-div {
      margin-right: auto;
    }

    .search-container {
      width: 100%;
      flex-direction: row;

      .search-select {
        margin-left: auto;
      }

      .search-div {
        flex-direction: row;
        width: 100%;

        input {
          width: calc(100% - 80px) !important;
        }

        .search-btn {
          min-width: 80px;
        }
      }
    }
  }
  /* [2026-08-25] 제목 줄만은 모바일에서도 한 줄로 둔다 — 바로 아래 .search-filter-row 의
     column 전환을 그대로 받으면 "검색 조건"과 토글이 위아래로 갈라져 두 줄을 먹는다.
     제목(좌)/토글(우) 한 줄이 이 줄의 존재 이유다. */
  .search-header-row {
    flex-direction: row;
    align-items: center;
    height: auto;
    padding: 8px 0;
  }

  .search-header-title {
    padding-left: 10px;
  }

  .advanced-toggle-btn {
    margin-right: 10px;
  }

  .search-filter-row {
    flex-direction: column;
    height: auto;

    &:nth-of-type(2) {
      .search-filter-content {
        flex-direction: column;
      }

      .search-filter-content {
        align-items: flex-start;
      }

      .date-selector-container.custom {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
      }
    }
  }
}

.progress-modal {
  width: 100vw; 
  height: 100vh; 
  background: rgba(0, 0, 0, 0.3); 
  overflow: hidden; 
  z-index: 10; 
  position: fixed; 
  top: 0; 
  left: 0;

  .progress-modal-body {
    border-radius: 16px;
    width: 400px;
    height: fit-content;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    flex-direction: column;
    padding: 20px;
    gap: 16px;

    .lottie-container {
      width: 200px;
    }

    .progress-desc {
      color: #2f3337;
    }
  }
}


/* ────────────────────────────────────────────────────────────────
   [2026-08-24] 목록 상단 재구성 — 통계 카드 / 모바일 필터 / 카드 목록
   모바일에서 통계 칩이 다운로드 버튼과 뒤엉키고 날짜 버튼이 2 열로 접혀
   레이아웃이 무너졌다(사용자 제보 스크린샷). 세 영역을 각자 정리한다.
   ──────────────────────────────────────────────────────────────── */

/* 통계 — 필터 위의 독립 카드 */
.stats-card {
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 12px;
}

.stats-card-head {
  display: flex;
  align-items: baseline;
  gap: 4px;
  margin-bottom: 10px;
}

.stats-total-label,
.stats-total-unit {
  font-size: 13px;
  color: #868e96;
}

.stats-total-value {
  font-size: 20px;
  font-weight: 700;
  color: #212529;
}

/* 상태 4 종을 균등 그리드로 — 좁아지면 2 열로 접히되 칸이 깨지지 않는다 */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.stat-box {
  display: block;              /* button 을 flex 컨테이너로 쓰지 않는다 — 자식이 눌린다 */
  padding: 8px 10px;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  text-align: left;
  min-width: 0;
  min-height: 58px;            /* button 은 grid stretch 가 안 먹어 높이를 직접 맞춘다 */
  width: 100%;
}

.stat-box-inner {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.stat-box.plain {
  cursor: default;
}

.stat-box-label {
  display: block;
  font-size: 11px;
  line-height: 16px;   /* 상속된 line-height 에 기대지 않는다 */
  color: #868e96;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.stat-box-value {
  display: block;
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
  color: #212529;
  font-variant-numeric: tabular-nums;
}

.stat-box.orange .stat-box-value { color: #fa8c16; }
.stat-box.green  .stat-box-value { color: #52c41a; }
.stat-box.red    .stat-box-value { color: #f5222d; }

.stat-box.active {
  border-color: #212529;
  background: #212529;
}

.stat-box.active .stat-box-label,
.stat-box.active .stat-box-value {
  color: #fff;
}

/* 같은 행의 칸 높이를 맞춘다(grid 는 행 단위로 stretch 하지만 button 이 따르지 않는다) */
.stats-grid {
  grid-auto-rows: minmax(58px, auto);
}

.stats-types {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #f0f0f0;
  font-size: 12px;
  color: #868e96;
}

.stats-types-label {
  flex: 0 0 auto;
}

/* 분류는 12 종까지 있어 줄바꿈으로 깨지느니 한 줄에서 가로 스크롤시킨다 */
.stats-types-list {
  display: flex;
  align-items: center;
  gap: 10px;
  overflow-x: auto;
  white-space: nowrap;
  min-width: 0;
}

.stats-type-item {
  color: #495057;
}

.stats-type-item b {
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.stats-type-more {
  color: #adb5bd;
}

/* 모바일 카드 목록 */
.contract-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 4px 0 12px;
}

.contract-card {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 12px 14px;
  background: #fff;
}

.cc-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.cc-type {
  margin: 0;
}

.cc-status {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.cc-status.orange { color: #fa8c16; }
.cc-status.green  { color: #52c41a; }
.cc-status.red    { color: #f5222d; }
.cc-status.gray   { color: #868e96; }
.cc-status.dentium_green { color: #7cb342; }

.cc-title {
  font-size: 14px;
  font-weight: 600;
  color: #212529;
  line-height: 1.4;
  margin-bottom: 6px;
  word-break: break-all;
}

.cc-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #868e96;
  margin-bottom: 2px;
}

.cc-dot {
  color: #dee2e6;
}

.cc-actions {
  display: flex;
  gap: 8px;
  margin-top: 10px;
}

.cc-actions .ant-btn {
  flex: 1;
}

@media screen and (max-width: 767px) {
  .stats-card {
    padding: 12px;
  }

  /* 4 열은 모바일에서 글자가 잘린다 — 2 열로 내린다 */
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .stats-total-value {
    font-size: 18px;
  }

  .stats-types-list::-webkit-scrollbar {
    height: 0;
  }
}
</style>
